// @flow

export const MMB_KEYS = Object.freeze({
  BAGGAGE: "BAGGAGE",
  SEATING: "SEATING",
  INSURANCE: "INSURANCE",
  MEALS: "MEALS",
  OFFERED_MEALS: "OFFERED_MEALS",
  PETS: "PETS",
  SPECIAL_ASSISTANCE: "SPECIAL_ASSISTANCE",
  SPORTS_EQUIPMENT: "SPORTS_EQUIPMENT",
  MUSICAL_EQUIPMENT: "MUSICAL_EQUIPMENT",
  ACCOMMODATION: "ACCOMMODATION",
  CAR_RENTAL: "CAR_RENTAL",
  AIRPORT_PARKING: "AIRPORT_PARKING",
  CHANGE_FLIGHTS: "CHANGE_FLIGHTS",
  TRANSFER: "TRANSFER",
  UBER: "UBER",
  EXTRA: "EXTRA",
  PRICE_CHANGE: "PRICE_CHANGE",
  SCHEDULE_CHANGE: "SCHEDULE_CHANGE",
  PASSENGER_EDIT: "PASSENGER_EDIT",
  ASSISTED_REFUND: "ASSISTED_REFUND",
  PRIORITY_BOARDING: "PRIORITY_BOARDING",
  INFANT: "INFANT",
})

export type MMBKeys = $Values<typeof MMB_KEYS>

export const BOOKING_STATUSES = {
  CLOSED: "closed",
  CONFIRMED: "confirmed",
  REFUNDED: "refunded",
  REFUNDING: "refunding",
}

// TODO: Make enum exhausting
export const SEATING_CHANGES_STATUSES = {
  CANCELLED: "cancelled",
  REFUNDED: "refunded",
}

export const MODALS = Object.freeze({
  PENDING_REQUESTS: "pendingRequests",
  PENDING_SERVICES: "pendingServices",
  CHANGE_FLIGHTS: "changeFlights",
  FLIGHTS_HISTORY: "flightsHistory",
  INSURANCE: "insurance",
  PAYMENT: "payment",
  SERVICES: "services",
  BOOKING_CANCELLATION: "bookingCancellation",
  PASSENGERS: "passengers",
  BAGS: "bags",
  REFUND: "refund",
  SEATING: "seating",
  MEALS: "meals_on_board",
  FAST_REFUND: "fastRefund",
  TICKETING: "ticketing",
  PASSENGER_EDIT: "passenger_edit",
  SPORTS_EQUIPMENT: "sports_equipment",
  MUSICAL_EQUIPMENT: "musical_equipment",
  SPECIAL_ASSISTANCE: "special_assistance",
  PETS: "travelling_with_pets",
  THANKYOU: "thankyou",
  COMPLETION_FEES: "completionFees",
  PENDING_REFUNDS: "pendingRefunds",
  CAR_HIRE: "carHire",
  PHONE_NUMBERS: "phoneNumbers",
  SCHEDULE_CHANGE: "scheduleChange",
  SCHEDULE_CHANGE_ALTERNATIVE_EXPIRED: "scheduleChangeAlternativeExpired",
  SCHEDULE_CHANGE_ALTERNATIVE_ERROR: "scheduleChangeAlternativeError",
  MOBILE_PROMO: "mobilePromo",
  CREDIT_PAYMENT_THANK_YOU: "creditPaymentThankyou",
  FLIGHT_CHANGE_PRICE_ERROR: "flightChangePriceError",
  PASSENGER_ATA: "passengerAta",
  JOURNEY_CHANGE_UNAVAILABLE: "journeyChangeUnavailable",
  INVOICES: "invoices",
})

export type Modals = $Values<typeof MODALS>

export const ACTIONS = {
  INVALIDATE: "invalidate",
  REQUEST_PENDING_REFUND: "requestPendingRefund",
  REQUEST_PENDING_SERVICE: "requestPendingService",
  REQUEST_ADDITIONAL_SERVICE_PAYMENT: "requestAdditionalServicePayment",
  REQUEST_FAST_REFUND: "requestFastRefund",
  CHANGE_BAGS: "changeBags",
  CHANGE_INSURANCE: "changeInsurance",
  ADDITIONAL_SERVICE_PAYMENT: "additionalServicePayment",
  CANCEL_BOOKING: "cancelBooking",
  ADDITIONAL_CONTACTS: "additionalContacts",
  CHANGE_PRIMARY_EMAIL: "changePrimaryEmail",
  UNSPECIFIED: "unspecified",
}

export const API_CATEGORIES = {
  ALLOCATED_SEATING: "allocated_seating",
  ASSISTED_REFUND: "assisted_refund",
  BAGGAGE: "baggage",
  BAGS: "bags",
  BOOKING_RESTORE: "booking.restore",
  EXTRA_BAGS: "extras.bags",
  EXTRAS_CHANGE_FLIGHT: "extras.change_flight",
  EXTRAS_OTHER: "extras.other",
  EXTRAS_PASSENGER_EDIT: "extras.passenger_details_change",
  FLIGHTS: "flights",
  INFANT: "infant",
  MEALS: "meals",
  MEALS_ON_BOARD: "meals_on_board",
  MUSICAL_EQUIPMENT: "musical_equipment",
  OTHER: "other",
  INSURANCES: "insurances",
  PASSENGER_EDIT: "passenger_details_change",
  PETS: "travelling_with_pets",
  PRICE_CHANGE: "price_change",
  PRIORITY_BOARDING: "priority_boarding",
  SEATING: "seating",
  SEAT_ORDERS: "seat_orders",
  SERVICE_BAGGAGE: "service.baggage",
  SERVICE_INFANT: "service.infant",
  SERVICE_MEALS_ON_BOARD: "service.meals_on_board",
  SERVICE_MUSICAL_EQUIPMENT: "service.musical_equipment",
  SERVICE_OTHER: "service.other",
  SERVICE_PETS: "service.travelling_with_pets",
  SERVICE_PRIORITY_BOARDING: "service.priority_boarding",
  SERVICE_SEATING: "service.allocated_seating",
  SERVICE_SPECIAL_ASSISTANCE: "service.special_assistance",
  SERVICE_SPORTS_EQUIPMENT: "service.sports_equipment",
  SPECIAL_ASSISTANCE: "special_assistance",
  SPORTS_EQUIPMENT: "sports_equipment",
  UPDATE_INSURANCES: "update_insurances",
  PRICE_CHANGES: "price_changes", // mambo
}

export const API_ACTIONS = {
  CREATE: "create",
  CANCEL: "cancel",
  REQUEST_PAYMENT: "requestPayment",
  FINISH_PAYMENT: "finishPayment",
}

export const CONTACT_ACTIONS = {
  CREATE_CONTACT: "createContact",
  REMOVE_CONTACT: "removeContact",
}

export const PLACE_TYPE = {
  SUBDIVISION: 1,
}

export const TICKETING_REASONS = {
  PASSENGER_DETAILS: "passenger_details",
  BOARDING_PASS: "boarding_passes",
  BAGGAGE: "baggages",
  TICKET_CORRECTION: "eticket_corrections",
  FLIGHT_CHANGE: "flight_changes",
  ADD_INFANT: "add_infants",
  GUARANTEE: "passengers_at_airport",
  OTHER: "others",
}

export const CONTEXTS = {
  MMB: "MMB",
  TYP: "TYP",
}
